import api from './api';

// Case-scoped event timeline (staff view). Uses the shared `api` axios client,
// so the JWT (and thus tenant scope) is attached automatically. The server
// returns firm-local label strings — render those directly; do NOT reformat the
// ISO in the browser (that would render in the viewer's timezone).
const caseEventsService = {
  getTimeline: async (caseId) => {
    const res = await api.get(`/case-events/${encodeURIComponent(caseId)}`);
    return res.data;
  },
};

export default caseEventsService;
